export default __webpack_public_path__ + "static/media/plowtopia.e67aa1c7.svg";